const animationListener = (node, done) => {
	// use the css transitionend event to mark the finish of a transition
	node.addEventListener('transitionend', done, false);
};

export default animationListener;
